module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/path.js
// module id = 27
// module chunks = 0